import { createRootRoute } from '@tanstack/react-router';
import { RootWebView } from '@/components/layout/RootWebView';
import { RouteFailure } from '@/components/layout/RouteFailure';
import { RouteNotFound } from '@/components/layout/RouteNotFound';

export const Route = createRootRoute({ component: RootWebView, errorComponent: RouteFailure, notFoundComponent: RouteNotFound });
